export default __webpack_public_path__ + "static/media/cover-11.ca3a0e93.webp";